import React, { useState } from "react";
import { Form, Button, Alert, Container } from "react-bootstrap";
import axios from "axios";

const ProductDeleter = () => {
  const [tags, setTags] = useState("");
  const [message, setMessage] = useState("");
  const [variant, setVariant] = useState("success");

  const handleDelete = async (e) => {
    e.preventDefault();
    const tagList = tags
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag !== "");

    try {
      const response = await axios.delete("/api/delete-products/", {
        data: { tags: tagList },
      });
      setVariant("success");
      setMessage(response.data.message);
    } catch (error) {
      setVariant("danger");
      setMessage("Error deleting products. Please try again.");
      console.error(error);
    }
  };

  return (
    <Container className="mt-4">
      <h3>Delete Products by Tag</h3>
      <Form onSubmit={handleDelete}>
        <Form.Group className="mb-3" controlId="formTags">
          <Form.Label>Enter Tag_No values (comma separated)</Form.Label>
          <Form.Control
            type="text"
            placeholder="e.g. TAG001, TAG002"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
          />
        </Form.Group>
        <Button variant="danger" type="submit">
          Delete Products
        </Button>
      </Form>
      {message && (
        <Alert className="mt-3" variant={variant}>
          {message}
        </Alert>
      )}
    </Container>
  );
};

export default ProductDeleter;
